/**
 * Vinyl Product — Scroll-Driven Parallax Controller
 * Stages:
 *   1 → Album cover hero
 *   2 → Specs circle (hover to reveal stat details)
 *   3 → Video (optional — only if data-vp-stage="3" exists in DOM)
 *   4 → Related products carousel (clip-path reveal, JS-populated)
 *   5 → Tracklist (normal scroll flow)
 */
(function () {
  'use strict';

  var ticking      = false;
  var currentStage = 0;
  var hasRelated   = false; // module-level so initRelated() can update it
  var bpDirty      = false; // signals onScroll to recompute breakpoints

  /* ------------------------------------------------------------------ */
  /* SCROLL-DRIVEN STAGE TRANSITIONS                                      */
  /* ------------------------------------------------------------------ */
  function computeAlbumOrigin() {
    var album = document.querySelector('[data-vp-album]');
    if (!album) return '50% 50%';
    var rect = album.getBoundingClientRect();
    var cx = Math.round(rect.left + rect.width / 2);
    var cy = Math.round(rect.top + rect.height / 2);
    return cx + 'px ' + cy + 'px';
  }

  function initParallax() {
    var stage1    = document.querySelector('[data-vp-stage="1"]');
    var stage2    = document.querySelector('[data-vp-stage="2"]');
    var stage3    = document.querySelector('[data-vp-stage="3"]'); // optional video
    var stage4rel = document.querySelector('[data-vp-stage="4"]'); // optional related
    var spacer    = document.querySelector('[data-vp-spacer]');
    var albumCover = document.querySelector('[data-vp-album]');
    if (!stage1 || !stage2 || !spacer) return;

    var hasVideo = !!stage3;
    hasRelated   = !!stage4rel; // write to module-level var

    // Mobile: CSS handles layout, skip parallax JS entirely
    if (window.innerWidth <= 900) {
      stage2.classList.add('vp-active');
      if (stage3)    { stage3.classList.add('vp-active');    initVideoPlayer(); }
      if (stage4rel) { stage4rel.classList.add('vp-active'); initRelated(); }
      return;
    }

    function getBreakpoints() {
      var rect      = spacer.getBoundingClientRect();
      var spacerTop = rect.top + window.scrollY;
      var spacerH   = spacer.offsetHeight;

      if (hasVideo && hasRelated) {
        return {
          s1to2: spacerTop + spacerH * 0.22,
          s2to3: spacerTop + spacerH * 0.45,  // specs → video
          s3to4: spacerTop + spacerH * 0.63,  // video → related
          s4end: spacerTop + spacerH * 0.82   // related → tracklist
        };
      } else if (hasVideo) {
        return {
          s1to2: spacerTop + spacerH * 0.30,
          s2to3: spacerTop + spacerH * 0.68,
          s3to4: spacerTop + spacerH * 0.90,  // unused (equals s4end)
          s4end: spacerTop + spacerH * 0.90
        };
      } else if (hasRelated) {
        return {
          s1to2: spacerTop + spacerH * 0.30,
          s2to3: spacerTop + spacerH * 0.62,  // specs → related
          s3to4: spacerTop + spacerH * 0.85,  // unused (equals s4end)
          s4end: spacerTop + spacerH * 0.85
        };
      } else {
        return {
          s1to2: spacerTop + spacerH * 0.30,
          s2to3: spacerTop + spacerH * 0.90,
          s3to4: spacerTop + spacerH * 0.90,
          s4end: spacerTop + spacerH * 0.90
        };
      }
    }

    function setStage(n) {
      if (n === currentStage) return;
      currentStage = n;

      if (n === 1) {
        stage1.classList.remove('vp-out');
        stage1.style.zIndex = '12';
        stage2.classList.remove('vp-active');
        stage2.style.clipPath = '';
        stage2.style.transition = '';
        stage2.style.zIndex = '11';
        if (stage3)    { stage3.classList.remove('vp-active');    stage3.style.zIndex = '10'; }
        if (stage4rel) { stage4rel.classList.remove('vp-active'); stage4rel.style.zIndex = '9'; }
        if (heroHeader) { heroHeader.style.transform = ''; heroHeader.style.opacity = ''; }

      } else if (n === 2) {
        var origin = computeAlbumOrigin();
        stage2.style.transition = 'none';
        stage2.style.clipPath = 'circle(0% at ' + origin + ')';
        stage2.style.zIndex = '13';
        stage2.getBoundingClientRect(); // force reflow
        stage2.style.transition = '';
        stage2.style.clipPath = 'circle(150% at ' + origin + ')';
        stage2.classList.add('vp-active');
        stage1.classList.remove('vp-out');
        stage1.style.zIndex = '11';
        if (stage3)    { stage3.classList.remove('vp-active');    stage3.style.zIndex = '10'; }
        if (stage4rel) { stage4rel.classList.remove('vp-active'); stage4rel.style.zIndex = '9'; }
        // Re-measure connectors — stage2 is now visible and fully laid out
        requestAnimationFrame(updateConnectors);

      } else if (n === 3 && hasVideo) {
        stage3.style.zIndex = '14';
        stage3.classList.add('vp-active');
        initVideoPlayer();
        stage2.classList.remove('vp-active');
        stage2.style.clipPath  = '';
        stage2.style.transition = '';
        stage2.style.zIndex = '11';
        stage1.classList.remove('vp-out');
        stage1.style.zIndex = '11';
        if (stage4rel) { stage4rel.classList.remove('vp-active'); stage4rel.style.zIndex = '9'; }
        // Prefetch related products while the user watches the video
        setTimeout(initRelated, 400);

      } else if (n === 4 && hasRelated) {
        stage4rel.style.zIndex = '14';
        stage4rel.classList.add('vp-active');
        initRelated();
        if (stage3) { stage3.classList.remove('vp-active'); stage3.style.zIndex = '10'; }
        // Must clear inline clip-path on stage2 — it was set directly by setStage(2)
        // and will bleed through if only the class is removed
        stage2.classList.remove('vp-active');
        stage2.style.clipPath  = '';
        stage2.style.transition = '';
        stage2.style.zIndex = '11';
        stage1.classList.remove('vp-out');
        stage1.style.zIndex = '11';

      } else {
        // Stage 5: tracklist — fade all fixed stages, let scroll continue
        stage1.classList.add('vp-out');
        stage1.style.zIndex = '11';
        stage2.classList.remove('vp-active');
        stage2.style.clipPath = '';
        stage2.style.transition = '';
        stage2.style.zIndex = '11';
        if (stage3)    { stage3.classList.remove('vp-active');    stage3.style.zIndex = '10'; }
        if (stage4rel) { stage4rel.classList.remove('vp-active'); stage4rel.style.zIndex = '9'; }
      }

      // Update progress dots
      // Stage 4 (related) has no dedicated dot — highlight stage 5 (tracklist) as the next target
      var activeDot = (n === 4) ? 5 : n;
      document.querySelectorAll('[data-vp-stage-dot]').forEach(function (dot) {
        dot.classList.toggle('vp-active', parseInt(dot.dataset.vpStageDot) === activeDot);
      });

      // Header lockup (logo + artist): hide on stage 1, slide in on stage 2+
      var headerLockup = document.querySelector('.vp__header-lockup');
      if (headerLockup) {
        headerLockup.classList.toggle('vp-visible', n > 1);
      }
    }

    var bp = getBreakpoints();
    var heroHeader = document.querySelector('[data-vp-hero-header]');

    // Debounced resize: handles mobile/desktop boundary crossing + stale breakpoints
    var resizeTimer;
    var lastMobile = window.innerWidth <= 900;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var nowMobile = window.innerWidth <= 900;
        if (nowMobile !== lastMobile) {
          lastMobile = nowMobile;
          if (nowMobile) {
            // Crossed to mobile: clear all desktop-injected inline styles
            [stage1, stage2, stage3, stage4rel].forEach(function (el) {
              if (!el) return;
              el.style.clipPath = ''; el.style.transition = '';
              el.style.zIndex  = ''; el.style.opacity    = '';
              el.classList.remove('vp-out');
              el.classList.add('vp-active');
            });
            if (heroHeader) { heroHeader.style.transform = ''; heroHeader.style.opacity = ''; }
            if (albumCover)  albumCover.style.transform = '';
            return;
          }
          // Crossed back to desktop: reset to stage 1 and re-init
          currentStage = 0;
          [stage2, stage3, stage4rel].forEach(function (el) {
            if (!el) return;
            el.classList.remove('vp-active');
            el.style.clipPath = ''; el.style.zIndex = '';
          });
        }
        // If already in stage 2 when resize happens, update the clip-path origin
        if (currentStage === 2) {
          var o = computeAlbumOrigin();
          stage2.style.clipPath = 'circle(150% at ' + o + ')';
        }
        bp = getBreakpoints();
        onScroll();
      }, 150);
    });

    function onScroll() {
      // Skip parallax on mobile — CSS handles layout
      if (window.innerWidth <= 900) { ticking = false; return; }
      var y = window.scrollY;
      if (y === 0 || bpDirty) { bp = getBreakpoints(); bpDirty = false; }

      var progress = bp.s1to2 > 0 ? Math.min(1, Math.max(0, y / bp.s1to2)) : 0;

      if (albumCover) {
        albumCover.style.transform = 'scale(' + (1 + progress * 0.10) + ')';
      }

      if (heroHeader && y < bp.s1to2) {
        var lift = progress * 40;
        var fade = Math.max(0, 1 - progress * 1.2);
        heroHeader.style.transform = 'translateY(-' + lift.toFixed(1) + 'px)';
        heroHeader.style.opacity   = fade.toFixed(3);
      }

      if (y < bp.s1to2) {
        setStage(1);
      } else if (y < bp.s2to3) {
        setStage(2);
      } else if (y < bp.s3to4) {
        // After specs: video if present, else related, else tracklist
        setStage(hasVideo ? 3 : (hasRelated ? 4 : 5));
      } else if (y < bp.s4end) {
        // After video: related if present, else tracklist
        setStage(hasRelated ? 4 : 5);
      } else {
        setStage(5);
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });

    onScroll();
  }

  /* ------------------------------------------------------------------ */
  /* VIDEO PLAYER — lazy-inject iframe on first entry to Stage 3         */
  /* ------------------------------------------------------------------ */
  var videoReady = false;

  function initVideoPlayer() {
    if (videoReady) return;
    var stage3  = document.querySelector('[data-vp-stage="3"]');
    var wrap    = stage3 && stage3.querySelector('[data-vp-video-wrap]');
    var rawUrl  = stage3 && stage3.dataset.vpVideo;
    if (!wrap || !rawUrl) return;

    var src = buildEmbedUrl(rawUrl);
    if (!src) {
      // Invalid URL — hide the video stage so a blank screen isn't shown
      var stageEl = document.querySelector('[data-vp-stage="3"]');
      if (stageEl) stageEl.style.display = 'none';
      return;
    }

    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.setAttribute('loading', 'lazy');
    wrap.appendChild(iframe);
    videoReady = true;
  }

  function buildEmbedUrl(url) {
    var ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    if (ytMatch) {
      return 'https://www.youtube.com/embed/' + ytMatch[1]
        + '?autoplay=1&mute=1&loop=1&playlist=' + ytMatch[1]
        + '&start=10&controls=1&rel=0&modestbranding=1';
    }
    var vmMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vmMatch) {
      return 'https://player.vimeo.com/video/' + vmMatch[1]
        + '?autoplay=1&muted=1&loop=1&title=0&byline=0&portrait=0';
    }
    if (/\.(mp4|webm|ogg)(\?|$)/i.test(url)) return url;
    return null;
  }

  /* ------------------------------------------------------------------ */
  /* RELATED PRODUCTS — fetch on first entry, render carousel            */
  /* ------------------------------------------------------------------ */
  var relatedReady = false;

  function initRelated() {
    if (relatedReady) return;
    var stage4 = document.querySelector('[data-vp-stage="4"]');
    if (!stage4) return;
    var track = stage4.querySelector('[data-vp-related-track]');
    if (!track) return;

    var section    = document.querySelector('[data-vp-section]');
    var productId  = section && section.dataset.vpProductId;
    var collHandle = stage4.dataset.vpCollection;
    if (!productId) return;

    // Read theme editor settings from data attributes
    var settings = {
      quickBuy:    stage4.dataset.vpQuickBuy    !== 'false',
      showFormat:  stage4.dataset.vpShowFormat  !== 'false',
      showPrice:   stage4.dataset.vpShowPrice   !== 'false',
      showSoldOut: stage4.dataset.vpShowSoldOut !== 'false',
      maxProds:    parseInt(stage4.dataset.vpMaxProducts || '12', 10),
      cardSize:    stage4.dataset.vpCardSize    || 'medium'
    };

    relatedReady = true;

    // Prefer collection endpoint (series-scoped) over generic recommendations
    var fetchUrl = collHandle
      ? '/collections/' + collHandle + '/products.json?limit=24'
      : '/recommendations/products.json?product_id=' + productId + '&limit=12&intent=related';

    fetch(fetchUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.products || [])
          .filter(function (p) {
            if (String(p.id) === String(productId)) return false;
            if (p.product_type === 'Gift Cards') return false;
            if (/gift.?card/i.test(p.title)) return false;
            return true;
          })
          .slice(0, settings.maxProds);

        if (!prods.length) {
          stage4.style.display = 'none';
          hasRelated = false;
          bpDirty    = true;
          return;
        }

        track.innerHTML = prods.map(function (p) {
          // ── Image ──────────────────────────────────────────────────────
          var rawSrc = '';
          if (p.featured_image) {
            rawSrc = typeof p.featured_image === 'string'
              ? p.featured_image
              : (p.featured_image.src || '');
          }
          if (!rawSrc && p.images && p.images.length) rawSrc = p.images[0].src || '';
          var imgSrc = rawSrc
            ? rawSrc.split('?')[0].replace(/_\d+x\d*(\.[a-z]+)$/i, '$1') + '?width=400'
            : '';

          // ── Price ──────────────────────────────────────────────────────
          var price = '';
          if (p.variants && p.variants.length) {
            var pv = parseFloat(p.variants[0].price);
            if (!isNaN(pv)) price = '$' + pv.toFixed(2).replace(/\.00$/, '');
          }
          if (!price && p.price_min) price = formatMoney(p.price_min);
          if (p.price_varies && price) price = 'From ' + price;
          // Single Record of the Month records: price only for record-club-rotm members.
          if (p.tags && p.tags.indexOf('rotm-exclusive') !== -1 && !window.__levRotmMember) price = '';

          // ── Parse "Artist - Album Title Format" ────────────────────────
          var dashIdx = p.title.indexOf(' - ');
          var artist  = dashIdx > -1 ? p.title.slice(0, dashIdx) : '';
          var rest    = dashIdx > -1 ? p.title.slice(dashIdx + 3) : p.title;
          var fmtRx   = /\s+((?:\d+x)?(?:LP|EP|7"|10"|12"|SP|CD)(?:\s*\+\s*[\w\s"]+)?(?:\s*\([^)]*\))?)\s*$/i;
          var fmtM    = rest.match(fmtRx);
          var format  = fmtM ? fmtM[1].trim() : '';
          var album   = fmtM ? rest.slice(0, rest.length - fmtM[0].length).trim() : rest.trim();

          // ── Variant / color line ───────────────────────────────────────
          var colorInfo = '';
          var opts = p.options || [];
          for (var oi = 0; oi < opts.length; oi++) {
            if (/color|colour|vinyl/i.test(opts[oi].name)) {
              var vals = opts[oi].values || [];
              colorInfo = vals.length === 1 ? vals[0] : vals.length + ' colors';
              break;
            }
          }
          if (!colorInfo && p.variants && p.variants.length > 1) {
            colorInfo = p.variants.length + ' variants';
          }
          var formatLine = [format, colorInfo].filter(Boolean).join(' \u2014 ');

          // ── Availability ───────────────────────────────────────────────
          var allSoldOut = p.variants && p.variants.length > 0 &&
            p.variants.every(function (v) { return !v.available; });
          var soldOutBadge = (allSoldOut && settings.showSoldOut)
            ? '<span class="vp__related-badge">Sold Out</span>' : '';

          // ── Quick buy — adds first available variant, no select dropdown ──
          var qbHtml = '';
          // Members-only gate (2026-10-14): club records (rotm/rvrb/club-exclusive tags) must never get a
          // standalone Add to Cart from the related rail. Mirrors snippets/buy-buttons.liquid.
          var _vpTags = (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',')).map(function (t) { return String(t).trim().toLowerCase(); });
          var _vpMemberOnly = _vpTags.some(function (t) { return t === 'rotm-exclusive' || t === 'rvrb-exclusive' || t === 'club-exclusive'; });
          if (_vpMemberOnly) {
            qbHtml = '<div class="vp__related-qb"><a class="vp__related-qb-btn" href="/products/record-of-the-month-subscription" style="display:flex;align-items:center;justify-content:center;text-decoration:none;">Members only</a></div>';
          } else if (settings.quickBuy) {
            if (allSoldOut) {
              qbHtml = '<div class="vp__related-qb">' +
                '<button class="vp__related-qb-btn" disabled>Sold Out</button></div>';
            } else {
              var avail = (p.variants || []).filter(function (v) { return v.available; });
              var vid = avail.length ? avail[0].id : (p.variants[0] && p.variants[0].id);
              qbHtml = '<div class="vp__related-qb">' +
                '<button class="vp__related-qb-btn" data-vp-qb-id="' + vid + '">Add to Cart</button>' +
                '</div>';
            }
          }

          return '<div class="vp__related-card" data-card-size="' + settings.cardSize + '">' +
            '<a class="vp__related-card-media" href="' + p.url + '" tabindex="-1">' +
            '<div class="vp__related-card-img">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + escHtml(p.title) + '">' : '') +
            soldOutBadge +
            '</div></a>' +
            '<a class="vp__related-card-info" href="' + p.url + '">' +
            (artist     ? '<p class="vp__related-card-artist">' + escHtml(artist) + '</p>' : '') +
            '<p class="vp__related-card-album">' + escHtml(album || p.title) + '</p>' +
            (formatLine && settings.showFormat ? '<p class="vp__related-card-format">' + escHtml(formatLine) + '</p>' : '') +
            (price && settings.showPrice ? '<p class="vp__related-card-price">' + price + '</p>' : '') +
            '</a>' +
            qbHtml +
            '</div>';
        }).join('');

        initRelatedCarousel(stage4);
      })
      .catch(function () {
        // On network error: clear skeletons, hide stage, recompute breakpoints
        track.innerHTML = '';
        stage4.style.display = 'none';
        hasRelated = false;
        bpDirty    = true;
        relatedReady = false; // allow retry if stage is ever re-shown
      });
  }

  function initRelatedCarousel(stage4) {
    var track   = stage4.querySelector('[data-vp-related-track]');
    var prevBtn = stage4.querySelector('[data-vp-related-prev]');
    var nextBtn = stage4.querySelector('[data-vp-related-next]');
    if (!track) return;

    function cardStep() {
      var card = track.querySelector('.vp__related-card');
      if (!card) return 220;
      var gap = parseInt(window.getComputedStyle(track).columnGap || '16', 10);
      return card.offsetWidth + gap;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep() * 2, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep() * 2, behavior: 'smooth' });
      });
    }

    function updateArrows() {
      var atStart = track.scrollLeft < 8;
      var atEnd   = track.scrollLeft >= track.scrollWidth - track.clientWidth - 8;
      if (prevBtn) prevBtn.style.opacity = atStart ? '0.2' : '1';
      if (nextBtn) nextBtn.style.opacity = atEnd   ? '0.2' : '1';
    }
    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    // Quick buy — delegate click to track
    track.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vp-qb-id]');
      if (btn) addRelatedToCart(btn, parseInt(btn.dataset.vpQbId, 10));
    });
  }

  function addRelatedToCart(btn, variantId) {
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        btn.textContent = data.description || 'Error';
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1500);
        return;
      }
      btn.textContent = 'Added!';
      btn.classList.add('vp__related-qb-btn--added');
      var cartCount = document.querySelector(
        '.header__cart-count, [data-cart-count], .cart-count, .js-cart-count'
      );
      if (cartCount) cartCount.textContent = (parseInt(cartCount.textContent, 10) || 0) + 1;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function () {
        btn.textContent = orig;
        btn.classList.remove('vp__related-qb-btn--added');
        btn.disabled = false;
      }, 1200);
    })
    .catch(function () {
      btn.textContent = 'Error';
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1500);
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ------------------------------------------------------------------ */
  /* SPEC CIRCLE — hover updates circle content in-place                  */
  /* ------------------------------------------------------------------ */
  function initCircle() {
    var section  = document.querySelector('[data-vp-section]');
    var stage2   = document.querySelector('[data-vp-stage="2"]');
    var circle   = document.querySelector('[data-vp-circle]');
    if (!section || !circle || !stage2) return;

    var labelEl  = circle.querySelector('[data-vp-circle-label]');
    var valueEl  = circle.querySelector('[data-vp-circle-value]');
    var textEl   = circle.querySelector('[data-vp-circle-text]');
    var circleImg = circle.querySelector('[data-vp-circle-img]');
    var stats    = section.querySelectorAll('[data-vp-stat]');
    var revertTimer;

    var albumImg = document.querySelector('[data-vp-album] img');
    function setCircleImg(src) {
      if (!circleImg || !src) return;
      circleImg.src = src;
      circleImg.style.display = '';
    }
    if (albumImg && albumImg.complete && albumImg.naturalWidth) {
      setCircleImg(albumImg.src);
    } else if (albumImg) {
      albumImg.addEventListener('load', function () { setCircleImg(albumImg.src); }, { once: true });
    }

    function showStat(stat) {
      clearTimeout(revertTimer);
      if (labelEl) labelEl.textContent = stat.dataset.statLabel  || '';
      if (valueEl) valueEl.textContent = stat.dataset.statValue  || '';
      if (textEl)  textEl.textContent  = stat.dataset.statDetail || stat.dataset.statValue || '';
      stage2.classList.add('vp-stat-focused');
      stats.forEach(function (s) { s.classList.toggle('vp-stat-active', s === stat); });
    }

    function revert() {
      revertTimer = setTimeout(function () {
        stage2.classList.remove('vp-stat-focused');
        stats.forEach(function (s) { s.classList.remove('vp-stat-active'); });
      }, 200);
    }

    stats.forEach(function (stat) {
      stat.addEventListener('mouseenter', function () { showStat(stat); });
      stat.addEventListener('mouseleave', revert);
      stat.addEventListener('focus',      function () { showStat(stat); });
      stat.addEventListener('blur',       revert);
      stat.addEventListener('click', function () {
        if (stat.classList.contains('vp-stat-active')) { revert(); }
        else { showStat(stat); }
      });
    });

    circle.addEventListener('mouseenter', function () { clearTimeout(revertTimer); });
    circle.addEventListener('mouseleave', revert);
  }

  /* ------------------------------------------------------------------ */
  /* VIDEO STAT LINK — clicking a stat with data-vp-stat-video scrolls   */
  /* to the video section                                                  */
  /* ------------------------------------------------------------------ */
  function initVideoStatLink() {
    var spacer = document.querySelector('[data-vp-spacer]');
    if (!spacer) return;

    document.querySelectorAll('[data-vp-stat-video]').forEach(function (stat) {
      stat.addEventListener('click', function () {
        var rect      = spacer.getBoundingClientRect();
        var spacerTop = rect.top + window.scrollY;
        var target    = spacerTop + spacer.offsetHeight * 0.47;
        window.scrollTo({ top: target, behavior: 'smooth' });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* NAV JUMPS — [data-vp-jump] buttons scroll to the target stage      */
  /* ------------------------------------------------------------------ */
  function initNavJumps() {
    var spacer = document.querySelector('[data-vp-spacer]');
    if (!spacer) return;

    var hasVideo   = !!document.querySelector('[data-vp-stage="3"]');
    var hasRelated = !!document.querySelector('[data-vp-stage="4"]');

    document.querySelectorAll('[data-vp-jump]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = parseInt(btn.dataset.vpJump, 10);
        var rect      = spacer.getBoundingClientRect();
        var spacerTop = rect.top + window.scrollY;
        var spacerH   = spacer.offsetHeight;

        var positions;
        if (hasVideo && hasRelated) {
          positions = {
            2: spacerTop + spacerH * 0.24,   // specs
            3: spacerTop + spacerH * 0.47,   // video
            5: spacerTop + spacerH * 0.84    // tracklist
          };
        } else if (hasVideo) {
          positions = {
            2: spacerTop + spacerH * 0.32,
            3: spacerTop + spacerH * 0.70,
            5: spacerTop + spacerH * 0.92
          };
        } else {
          positions = {
            2: spacerTop + spacerH * 0.32,
            5: spacerTop + spacerH * 0.92
          };
        }

        // "Tracklist" jump button uses data-vp-jump="5"
        var dest = positions[target];
        if (dest !== undefined) {
          window.scrollTo({ top: dest, behavior: 'smooth' });
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* STICKY ATC BAR                                                       */
  /* ------------------------------------------------------------------ */
  function initATC() {
    var bar = document.querySelector('[data-vp-atc-bar]');
    if (!bar) return;

    var select      = bar.querySelector('[data-vp-variant-select]');
    var hiddenInput = bar.querySelector('[data-vp-variant-id]');
    var priceEl     = bar.querySelector('[data-vp-price]');
    var labelEl     = bar.querySelector('[data-vp-btn-label]');
    var qtyInput    = bar.querySelector('[data-vp-qty-input]');
    var btn         = bar.querySelector('.vp__atc-btn');
    var form        = bar.querySelector('[data-vp-form]');
    if (!form) return;

    if (select && hiddenInput) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        hiddenInput.value = select.value;
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        var soldOut = opt.disabled;
        btn.disabled = soldOut;
        if (labelEl) labelEl.textContent = soldOut ? 'Sold Out' : 'Add to Cart';
        document.querySelectorAll('.vp__swatch').forEach(function (sw) {
          sw.classList.toggle('vp__swatch--active', sw.dataset.variantId === select.value);
        });
      });
      select.dispatchEvent(new Event('change'));
    }

    document.querySelectorAll('.vp__swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        if (!select) return;
        select.value = sw.dataset.variantId;
        select.dispatchEvent(new Event('change'));
      });
    });

    bar.querySelectorAll('[data-vp-qty]').forEach(function (qBtn) {
      qBtn.addEventListener('click', function () {
        if (!qtyInput) return;
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = qBtn.dataset.vpQty === '+' ? val + 1 : Math.max(1, val - 1);
      });
    });

    btn.addEventListener('click', function () {
      var id  = hiddenInput ? hiddenInput.value : '';
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!id) return;

      // Mirror AddToCart custom element: get section IDs for drawer + bubble re-render
      var cartDrawerSection = document.querySelector('.shopify-section-cart-drawer');
      var headerSection     = document.querySelector('.shopify-section-header');
      var cartDrawerID = cartDrawerSection ? cartDrawerSection.id.replace('shopify-section-', '') : null;
      var headerID     = headerSection     ? headerSection.id.replace('shopify-section-', '')     : null;
      var sections = [cartDrawerID, headerID].filter(Boolean);

      btn.disabled = true;
      btn.classList.add('loading');

      fetch(window.routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: parseInt(id, 10),
          quantity: qty,
          sections: sections,
          sections_url: window.location.pathname
        })
      })
      .then(function (r) { return r.json(); })
      .then(function (parsedState) {
        if (parsedState.status === 422) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
            detail: { errorMessage: parsedState.description }
          }));
          return;
        }
        // Let cart drawer / notification handle itself (same as AddToCart element)
        var miniCart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (miniCart && typeof miniCart.renderContents === 'function') {
          miniCart.renderContents(parsedState);
        }
        // Update header cart bubble
        if (headerID && parsedState.sections && parsedState.sections[headerID]) {
          var bubbles = document.querySelectorAll('#cart-icon-bubble-' + headerID);
          var parser  = new DOMParser();
          var doc     = parser.parseFromString(parsedState.sections[headerID], 'text/html');
          bubbles.forEach(function (el) {
            var updated = doc.querySelector('#cart-icon-bubble-' + headerID);
            if (updated) el.innerHTML = updated.innerHTML;
          });
        }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: parsedState }
        }));
      })
      .catch(function (e) { console.error(e); })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('loading');
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* HEADER LOGO — inject animated logo into site nav center            */
  /* Only runs on this page; removed on section unload                   */
  /* ------------------------------------------------------------------ */
  function injectHeaderLogo() {
    var section    = document.querySelector('[data-vp-section]');
    var logoUrl    = section && section.dataset.vpHeaderLogo;
    var artistName = section && section.dataset.vpHeaderArtist;
    if (!logoUrl) return;
    if (document.querySelector('.vp__header-lockup')) return;

    var container = document.querySelector('.main-header');
    if (!container) {
      container = document.querySelector('header.header, .site-header, header[role="banner"]');
    }
    if (!container) return;

    var lockup = document.createElement('div');
    lockup.className = 'vp__header-lockup';
    lockup.setAttribute('aria-hidden', 'true');

    var img = document.createElement('img');
    img.src       = logoUrl;
    img.className = 'vp__header-logo';
    img.alt       = '';
    lockup.appendChild(img);

    if (artistName) {
      var artist = document.createElement('span');
      artist.className   = 'vp__header-artist';
      artist.textContent = artistName;
      lockup.appendChild(artist);
    }

    container.appendChild(lockup);
  }

  function removeHeaderLogo() {
    var el = document.querySelector('.vp__header-lockup');
    if (el) el.parentNode.removeChild(el);
  }

  /* ------------------------------------------------------------------ */
  /* MEASURE SITE NAV — injects --vp-nav-h so CSS padding is reliable    */
  /* ------------------------------------------------------------------ */
  function measureNav() {
    var h = 0;

    // Preferred: read --header-height from the Volume theme's sticky-header element.
    // The theme sets it there via inline style but never propagates to :root, so
    // elements outside the header's DOM subtree (like our fixed stages) can't inherit it.
    var stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      h = parseInt(getComputedStyle(stickyHeader).getPropertyValue('--header-height') || '0', 10) || 0;
    }

    // Fallback: measure the bottom edge of the first fixed/sticky header element.
    if (!h) {
      var nav = document.querySelector(
        '.site-header, header.site-header, [data-section-type="header"], ' +
        '.header__wrapper, .header-wrapper, header[role="banner"], ' +
        'header:not([data-vp-section])'
      );
      h = nav ? Math.round(nav.getBoundingClientRect().bottom) : 0;
    }
    if (!h) {
      var fixed = Array.from(document.querySelectorAll('header, [class*="header"]'));
      fixed.forEach(function (el) {
        var s = window.getComputedStyle(el);
        if ((s.position === 'fixed' || s.position === 'sticky') && el.offsetHeight > h) {
          h = el.offsetHeight;
        }
      });
    }
    if (!h) h = 72;

    // Propagate to our section so var(--header-height) resolves correctly for all stages.
    var section = document.querySelector('[data-vp-section]');
    if (section) section.style.setProperty('--header-height', h + 'px');
    document.documentElement.style.setProperty('--vp-nav-h', (h + 4) + 'px');
  }

  /* ------------------------------------------------------------------ */
  /* HEADER FILL-BACK — transparent at top, filled on scroll             */
  /* ------------------------------------------------------------------ */
  function initHeaderFillBack() {
    var header = document.querySelector('.shopify-section-header .header');
    if (!header) return;
    // Always transparent on vinyl product pages — no scroll threshold
    header.classList.add('header--transparent');
  }

  /* ------------------------------------------------------------------ */
  /* CONNECTORS — measure actual pixel gap, set --vp-connector-w per stat */
  /* ------------------------------------------------------------------ */
  function updateConnectors() {
    var circle = document.querySelector('[data-vp-circle]');
    if (!circle) return;
    // Skip on mobile — connectors are hidden via CSS
    if (window.innerWidth <= 900) return;

    var circleRect = circle.getBoundingClientRect();

    document.querySelectorAll('.vp__stat-col--left .vp__stat').forEach(function (stat) {
      var statRect = stat.getBoundingClientRect();
      var gap = circleRect.left - statRect.right;
      stat.style.setProperty('--vp-connector-w', Math.max(0, gap) + 'px');
    });

    document.querySelectorAll('.vp__stat-col--right .vp__stat').forEach(function (stat) {
      var statRect = stat.getBoundingClientRect();
      var gap = statRect.left - circleRect.right;
      stat.style.setProperty('--vp-connector-w', Math.max(0, gap) + 'px');
    });
  }

  function initConnectors() {
    // Run once after layout settles, then update on resize
    requestAnimationFrame(function () {
      requestAnimationFrame(updateConnectors); // double-rAF ensures paint has occurred
    });
    window.addEventListener('resize', function () {
      requestAnimationFrame(updateConnectors);
    });
  }

  /* ------------------------------------------------------------------ */
  /* INIT                                                                  */
  /* ------------------------------------------------------------------ */
  function init() {
    measureNav();
    injectHeaderLogo();
    initParallax();
    initCircle();
    initConnectors();
    initNavJumps();
    initATC();
    initVideoStatLink();
    initHeaderFillBack();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-vp-section]')) {
      videoReady   = false;
      relatedReady = false;
      setTimeout(init, 50);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.querySelector('[data-vp-section]')) {
      removeHeaderLogo();
    }
  });

})();
